import { Link } from "react-router-dom";
import Header from "@/components/Header";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-eje/[0.03]">
      <Header variant="light" />
      <main className="flex-1 flex items-center justify-center text-center px-6">
        <div>
          <div className="font-serif text-7xl text-eje">404</div>
          <h1 className="font-serif text-2xl text-eje mt-3">
            Página no encontrada
          </h1>
          <p className="text-slate-600 mt-2">
            La ruta solicitada no existe.
          </p>
          <Link to="/" className="btn-primary-eje mt-6 inline-block">
            Volver al inicio
          </Link>
        </div>
      </main>
    </div>
  );
}
